var $35da740d59af89ba$exports = {};
const $35da740d59af89ba$var$reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const $35da740d59af89ba$var$finePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
document.documentElement.classList.add("js");
// lets :active styles (the logo keypress) fire on iOS taps
document.addEventListener("touchstart", ()=>{}, {
    passive: true
});
requestAnimationFrame(()=>document.body.classList.add("is-loaded"));
// Nav: firm up after scrolling, highlight the section in view
const $35da740d59af89ba$var$nav = document.getElementById("nav");
const $35da740d59af89ba$var$onScroll = ()=>$35da740d59af89ba$var$nav.classList.toggle("is-scrolled", window.scrollY > 24);
$35da740d59af89ba$var$onScroll();
window.addEventListener("scroll", $35da740d59af89ba$var$onScroll, {
    passive: true
});
const $35da740d59af89ba$var$navLinks = [
    ...document.querySelectorAll("[data-nav]")
];
const $35da740d59af89ba$var$sectionObserver = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        if (!entry.isIntersecting) return;
        $35da740d59af89ba$var$navLinks.forEach((link)=>link.classList.toggle("is-active", link.hash === `#${entry.target.id}`));
    });
}, {
    rootMargin: "-45% 0px -50% 0px"
});
$35da740d59af89ba$var$navLinks.forEach((link)=>{
    const section = document.querySelector(link.hash);
    if (section) $35da740d59af89ba$var$sectionObserver.observe(section);
});
// Reveal on scroll
const $35da740d59af89ba$var$revealObserver = new IntersectionObserver((entries, observer)=>{
    entries.forEach((entry)=>{
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-in");
        observer.unobserve(entry.target);
    });
}, {
    rootMargin: "0px 0px -8% 0px",
    threshold: 0.12
});
document.querySelectorAll(".reveal").forEach((el)=>$35da740d59af89ba$var$revealObserver.observe(el));
// Cursor-following light: hero spotlight and card edge glow
if ($35da740d59af89ba$var$finePointer && !$35da740d59af89ba$var$reduceMotion) {
    const hero = document.querySelector("[data-spot]");
    hero?.addEventListener("pointermove", (e)=>{
        const r = hero.getBoundingClientRect();
        hero.style.setProperty("--mx", `${e.clientX - r.left}px`);
        hero.style.setProperty("--my", `${e.clientY - r.top}px`);
    });
    document.querySelectorAll("[data-glow]").forEach((el)=>{
        el.addEventListener("pointermove", (e)=>{
            const r = el.getBoundingClientRect();
            el.style.setProperty("--gx", `${e.clientX - r.left}px`);
            el.style.setProperty("--gy", `${e.clientY - r.top}px`);
        });
    });
}
// Terminal tile: types out a deploy, loops while visible
const $35da740d59af89ba$var$typer = document.querySelector("[data-typer]");
if ($35da740d59af89ba$var$typer) {
    const script = [
        [
            "$ ",
            "git push origin main"
        ],
        [
            "",
            "\u2713 e2e tests passed"
        ],
        [
            "",
            "\u2713 built api \xb7 worker \xb7 web"
        ],
        [
            "$ ",
            "deploy --to production"
        ],
        [
            "",
            "\u2713 live"
        ]
    ];
    // An invisible copy of the finished output reserves the card's final
    // height, so the tile doesn't grow line by line while typing.
    const ghost = document.querySelector("[data-typer-ghost]");
    if (ghost) ghost.textContent = script.map(([p, t])=>p + t).join("\n") + "\n ";
    if ($35da740d59af89ba$var$reduceMotion) $35da740d59af89ba$var$typer.textContent = script.map(([p, t])=>p + t).join("\n");
    else {
        // Each run gets an id; starting a new run (or leaving the viewport)
        // bumps it, so an older loop always stops instead of interleaving.
        let runId = 0;
        const sleep = (ms)=>new Promise((r)=>setTimeout(r, ms));
        const run = async (id)=>{
            while(id === runId){
                $35da740d59af89ba$var$typer.textContent = "";
                for (const [prompt, text] of script){
                    if (id !== runId) return;
                    $35da740d59af89ba$var$typer.textContent += prompt;
                    if (prompt) for (const ch of text){
                        if (id !== runId) return;
                        $35da740d59af89ba$var$typer.textContent += ch;
                        await sleep(45);
                    }
                    else $35da740d59af89ba$var$typer.textContent += text;
                    $35da740d59af89ba$var$typer.textContent += "\n";
                    await sleep(prompt ? 420 : 280);
                }
                await sleep(2600);
            }
        };
        new IntersectionObserver(([entry])=>{
            runId += 1;
            if (entry.isIntersecting) run(runId);
        }).observe($35da740d59af89ba$var$typer);
    }
}
// Experience timeline: progress rail follows the scroll
const $35da740d59af89ba$var$trail = document.querySelector("[data-trail]");
if ($35da740d59af89ba$var$trail) {
    const update = ()=>{
        const r = $35da740d59af89ba$var$trail.getBoundingClientRect();
        const p = (window.innerHeight * 0.6 - r.top) / r.height;
        $35da740d59af89ba$var$trail.style.setProperty("--trail", Math.min(1, Math.max(0, p)).toFixed(4));
    };
    update();
    window.addEventListener("scroll", ()=>requestAnimationFrame(update), {
        passive: true
    });
    window.addEventListener("resize", update);
}
// Decorb before/after: the wipe follows the scroll position only
const $35da740d59af89ba$var$compare = document.querySelector("[data-compare]");
if ($35da740d59af89ba$var$compare) {
    const set = (p)=>$35da740d59af89ba$var$compare.style.setProperty("--p", Math.min(1, Math.max(0, p)).toFixed(4));
    const fromScroll = ()=>{
        const rect = $35da740d59af89ba$var$compare.getBoundingClientRect();
        const vh = window.innerHeight;
        // 0 when the image's top enters at 85% of the viewport, 1 when its center reaches 40%
        const start = vh * 0.85;
        const end = vh * 0.4 - rect.height / 2;
        set((start - rect.top) / (start - end));
    };
    if ($35da740d59af89ba$var$reduceMotion) set(0.5);
    else {
        let ticking = false;
        const queue = ()=>{
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(()=>{
                fromScroll();
                ticking = false;
            });
        };
        fromScroll();
        window.addEventListener("scroll", queue, {
            passive: true
        });
        window.addEventListener("resize", queue);
    }
}
// Copy email
document.querySelectorAll("[data-copy]").forEach((btn)=>{
    const label = btn.querySelector("[data-copy-label]");
    const initial = label.textContent;
    btn.addEventListener("click", async ()=>{
        try {
            await navigator.clipboard.writeText(btn.dataset.copy);
            label.textContent = "Copied \u2713";
        } catch  {
            label.textContent = "Couldn't copy";
        }
        setTimeout(()=>label.textContent = initial, 1800);
    });
});
document.querySelectorAll("[data-year]").forEach((el)=>el.textContent = new Date().getFullYear());
// ── Easter eggs ─────────────────────────────────────────────
// Altimeter: scrolling the page climbs to Everest base camp
const $35da740d59af89ba$var$SUMMIT = 5364;
const $35da740d59af89ba$var$altimeter = document.querySelector("[data-altimeter]");
if ($35da740d59af89ba$var$altimeter) {
    const out = $35da740d59af89ba$var$altimeter.querySelector("[data-alt]");
    let idle = 0;
    const climb = ()=>{
        const max = document.documentElement.scrollHeight - window.innerHeight;
        const p = max > 0 ? Math.min(1, window.scrollY / max) : 0;
        out.textContent = Math.round(p * $35da740d59af89ba$var$SUMMIT).toLocaleString("en-IN");
        const atTop = p > 0.995;
        $35da740d59af89ba$var$altimeter.classList.toggle("is-summit", atTop);
        // show while climbing, tuck away when the reader stops
        if (window.scrollY > window.innerHeight * 0.5) {
            $35da740d59af89ba$var$altimeter.classList.add("is-on");
            clearTimeout(idle);
            idle = setTimeout(()=>!$35da740d59af89ba$var$altimeter.classList.contains("is-summit") && $35da740d59af89ba$var$altimeter.classList.remove("is-on"), 1400);
        } else $35da740d59af89ba$var$altimeter.classList.remove("is-on");
    };
    climb();
    window.addEventListener("scroll", ()=>requestAnimationFrame(climb), {
        passive: true
    });
}
// Summits: when the reader reaches the very bottom, the two peaks I've
// climbed rise up, hold for a moment, then tuck away to reveal the footer
const $35da740d59af89ba$var$trek = document.querySelector("[data-trek]");
if ($35da740d59af89ba$var$trek) {
    const HOLD = 3600; // long enough for the flags to land, then out
    let closeTimer = 0;
    let armed = true;
    const close = ()=>{
        $35da740d59af89ba$var$trek.classList.remove("is-open");
        $35da740d59af89ba$var$trek.setAttribute("aria-hidden", "true");
        clearTimeout(closeTimer);
    };
    const open = ()=>{
        $35da740d59af89ba$var$trek.classList.add("is-open");
        $35da740d59af89ba$var$trek.setAttribute("aria-hidden", "false");
        clearTimeout(closeTimer);
        closeTimer = setTimeout(close, HOLD);
    };
    const check = ()=>{
        const fromBottom = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
        if (armed && fromBottom < 4) {
            armed = false;
            open();
        } else if (!armed && fromBottom > window.innerHeight * 0.6) armed = true; // scrolled well away; replay next time they reach the end
    };
    window.addEventListener("scroll", ()=>requestAnimationFrame(check), {
        passive: true
    });
    window.addEventListener("keydown", (e)=>e.key === "Escape" && close());
    $35da740d59af89ba$var$trek.addEventListener("click", close);
}
// Tabla: D (dayan, "Na") and B (bayan, "Ge") while the Life section is on screen
const $35da740d59af89ba$var$tabla = document.querySelector("[data-tabla]");
if ($35da740d59af89ba$var$tabla) {
    let ctx;
    let visible = false;
    new IntersectionObserver(([entry])=>visible = entry.isIntersecting).observe($35da740d59af89ba$var$tabla);
    const strike = (kind)=>{
        ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
        const t = ctx.currentTime;
        const out = ctx.createGain();
        out.connect(ctx.destination);
        if (kind === "na") [
            1,
            2,
            3.01
        ].forEach((h, i)=>{
            const o = ctx.createOscillator();
            const g = ctx.createGain();
            o.frequency.value = 330 * h;
            g.gain.setValueAtTime(0.3 / (i + 1), t);
            g.gain.exponentialRampToValueAtTime(0.0001, t + 0.9 / (i + 1));
            o.connect(g).connect(out);
            o.start(t);
            o.stop(t + 1);
        });
        else {
            const o = ctx.createOscillator();
            const g = ctx.createGain();
            o.frequency.setValueAtTime(140, t);
            o.frequency.exponentialRampToValueAtTime(70, t + 0.35);
            g.gain.setValueAtTime(0.7, t);
            g.gain.exponentialRampToValueAtTime(0.0001, t + 0.7);
            o.connect(g).connect(out);
            o.start(t);
            o.stop(t + 0.8);
        }
        $35da740d59af89ba$var$tabla.classList.remove("is-hit");
        $35da740d59af89ba$var$tabla.offsetWidth;
        $35da740d59af89ba$var$tabla.classList.add("is-hit");
    };
    window.addEventListener("keydown", (e)=>{
        if (!visible || e.repeat || e.metaKey || e.ctrlKey || e.altKey) return;
        const key = e.key.toLowerCase();
        if (key === "d") strike("na");
        if (key === "b") strike("ge");
    });
}


//# sourceMappingURL=repo.e718fbdb.js.map
